
export default {
  props: {
    fixture: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      tabTitles: [`Full Match`, `First Half`, `Second Half`],
      currentTab: `Full Match`,
      keyEventsOnly: false,
    };
  },
  computed: {
    firstHalf () { // TODO: see if firstHalf/secondHalf/outputFeed computeds can be merged with `feed.js` counterparts
      if (this.feed) {
        let feed = [...this.feed].filter(
          event => event.state.sourceName === `FirstHalf`,
        );

        if (this.hasSubstitutions(this.keyEventsOnly)) {
          const substitutions = this.substitutions.filter(
            event => event?.state?.sourceName === `FirstHalf`,
          );
          feed = [...feed, ...substitutions];
        }
        return this.sortLiveFeed(feed);
      }
      return [];
    },
    secondHalf () {
      if (this.feed) {
        let feed = [...this.feed].filter(
          event => event.state.sourceName === `SecondHalf`,
        );

        if (this.hasSubstitutions(this.keyEventsOnly)) {
          const substitutions = this.substitutions.filter(
            event => event?.state?.sourceName === `SecondHalf`,
          );
          feed = [...feed, ...substitutions];
        }
        return this.sortLiveFeed(feed);
      }
      return [];
    },
    outputFeed () {
      let feed = [];
      if (this.feed) {
        if (this.currentTab === `First Half`) {
          feed = this.firstHalf;
        } else if (this.currentTab === `Second Half`) {
          feed = this.secondHalf;
        } else {
          const etFirstHalf = [...this.feed].filter(
            event => event.state.sourceName === `ExtraTimeFirstHalf`,
          );
          const etSecondHalf = [...this.feed].filter(
            event => event.state.sourceName === `ExtraTimeSecondHalf`,
          );
          feed = [...etSecondHalf, ...etFirstHalf, ...this.secondHalf, ...this.firstHalf];
        }

        if (this.keyEventsOnly) {
          if (this.hasSubstitutions(this.keyEventsOnly)) {
            feed = feed.filter(event => !event.matchEventType || this.keyMatchEventIds.includes(event.matchEventType.id));
          } else {
            feed = feed.filter(event => event.matchEventType && this.keyMatchEventIds.includes(event.matchEventType.id));
          }
        }

        if (this.penaltiesOnly(this.keyEventsOnly)) {
          feed = this.removeNonPenalty(feed);
        }
      }

      return feed;
    },
    substitutions () {
      const home = this.getTeam(this.fixture, `Home`);
      const away = this.getTeam(this.fixture, `Away`);
      const homeSubs = home.substitutions.map(sub => {
        sub.team = home;
        return sub;
      });
      const awaySubs = away.substitutions.map(sub => {
        sub.team = away;
        return sub;
      });
      return [...homeSubs, ...awaySubs];
    },
    tabs () {
      const tabs = [`Full Match`];
      if (this.firstHalf.length) {
        tabs.push(`First Half`);
      }
      if (this.secondHalf.length) {
        tabs.push(`Second Half`);
      }
      return tabs;
    },
    keyIncludeSubs () {
      return this.additionalConfig?.match_centre_config?.key_match_events?.include_subs;
    },
    keyMatchEventIds () {
      const events = this.additionalConfig?.match_centre_config?.key_match_events?.match_events?.matcheventtype;
      if (events) {
        return events.map(event => event.id);
      }
      return [];
    },
    outputFeedInformation () { // TODO: merge with counterpart in `feed.js`
      const eventTypeInformation = [];
      for (const item of this.outputFeed) {
        if (item.matchEventType) {
          eventTypeInformation.push(
            this.getEventTypeInformation({
              event: item,
              feedItemInformation: this.feedItemInformation,
              timeEvents: this.timeEvents,
            }),
          );
        } else {
          eventTypeInformation.push(null);
        }
      }
      return eventTypeInformation;
    },
  },
  watch: {
    fixture: {
      immediate: true,
      deep: true,
      async handler (fixture) {
        this.fixtureWithMatchEvents =
          await this.generateNewFixtureWithMatchEventsObject(
            fixture,
            this.matchEvents,
          );
      },
    },
  },
  methods: {
    hasSubstitutions (key = false) {
      const subKey = key ? `key_match_events` : `live_feed_events`;
      return this.additionalConfig?.match_centre_config[subKey]?.include_substitutions;
    },
    penaltiesOnly (key = false) {
      const subKey = key ? `key_match_events` : `live_feed_events`;
      return this.additionalConfig?.match_centre_config[subKey]?.penalties_only;
    },
  },
};
